import { render, staticRenderFns } from "./ContractDetailRedirect.vue?vue&type=template&id=09a16242&scoped=true&"
import script from "./ContractDetailRedirect.vue?vue&type=script&lang=js&"
export * from "./ContractDetailRedirect.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetailRedirect.vue?vue&type=style&index=0&id=09a16242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a16242",
  null
  
)

export default component.exports